module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="form-group">\r\n    <input type="text" id="mejoras_descripcion" class="form-control" value="'+
((__t=(attributes.mejoras_descripcion))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
' />\r\n</td>\r\n<td class="form-group">\r\n    <div class="input-group" id="dtpickerMejoras">\r\n        <input type=\'text\' id="mejoras_fecha" class="form-control date" value="'+
((__t=(attributes.mejoras_fecha))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n        <span class="input-group-addon">\r\n            <span class="glyphicon glyphicon-calendar"></span>\r\n        </span>\r\n    </div>\r\n</td>\r\n<td class="form-group">\r\n    <div class="input-icon input-icon-right">\r\n        <i>€</i>\r\n        <input type="text" placeholder="0,00" id="mejoras_importe" class="form-control money text-right" value="'+
((__t=( attributes.mejoras_importe ))==null?'':_.escape(__t))+
'" '+
((__t=( disabled ))==null?'':_.escape(__t))+
'/>\r\n    </div>\r\n</td>\r\n<td class="form-group">\r\n    <input type="text" id="mejoras_operacion" class="form-control" value="'+
((__t=(attributes.mejoras_operacion))==null?'':_.escape(__t))+
'" '+
((__t=(disabled))==null?'':_.escape(__t))+
'/>\r\n</td>\r\n<td class="form-group">\r\n    ';

        disabledcheck2 = "";
        var checked = "";
       if(encurso == 1){
            checked = "checked";
            disabledcheck = "disabled";
        }
        else{
            if (attributes.mejoras_enCurso == 1){
                checked = "checked";
                disabledcheck2 = "disabled";
            }
        } 
        
__p+='\r\n        <input type="checkbox" id="mejoras_encurso" '+
((__t=( checked ))==null?'':_.escape(__t))+
' />\r\n\r\n</td>\r\n\r\n<td class="form-group">\r\n    <select id="mejoras_cuenta" class="form-control" '+
((__t=( disabled))==null?'':_.escape(__t))+
'>\r\n    ';

        var cuentas  = parameters.amortizaciones;
        var cuenta = cuentas[0];
        var cuentacheckVida = null;
         
        
        for(var i in cuentas){
            var selected = "";
            if(cuentas[i].epigraph === epi){
               
                cuentacheckVida =  cuentas[i];
                if(attributes.mejoras_cuenta === cuentas[i].item){
                
                    selected = "selected";
                    cuenta = cuentas[i]; 
                    
                }
            
               
                if($("tr#mejoras_encurso").is(":checked") || encurso == 1 || attributes.mejoras_enCurso == 1)
                    print('<option value="' + cuentas[i].item + '" ' + selected + '>' + cuentas[i].cc_encurso + " -- " + cuentas[i].translation +'</option>');
                else
                    print('<option value="' + cuentas[i].item + '" ' + selected + '>' + cuentas[i].cc_inmobil + " -- " + cuentas[i].translation +'</option>');
                
            }
        }
    
__p+='\r\n    </select>\r\n</td>\r\n';

  

var vidaCuentUtil = cuenta.vida_util;
var porcentaAmortiza = cuenta.amortizacion;
 
if(isnuevamejora == 1){ 
    vidaCuentUtil = cuentacheckVida['vida_util'];
    porcentaAmortiza =  cuentacheckVida['amortizacion'];
}else{
   
    if(attributes.mejoras_vida){
        vidaCuentUtil = attributes.mejoras_vida;
        porcentaAmortiza = 100/vidaCuentUtil;
        porcentaAmortiza = porcentaAmortiza.toFixed(2);
 
    } 
}
 
  
 

__p+='\r\n\r\n    <td class="form-group">\r\n        <input type="text" id="mejoras_vida" class="form-control integer" value="'+
((__t=(vidaCuentUtil))==null?'':_.escape(__t))+
'" '+
((__t=(disabledcheck2))==null?'':_.escape(__t))+
' />\r\n    </td>\r\n    <td class="form-group">\r\n        ';

    if($("tr#mejoras_encurso").is(":checked") || encurso == 1 || attributes.mejoras_enCurso == 1)
        print('<input type="text" id="mejoras_amortizacion" class="form-control money" disabled value="0,00" />');
    else{
        print('<input type="text" id="mejoras_amortizacion" class="form-control money" disabled value="' + porcentaAmortiza +'" />');
    }
    
__p+='\r\n    </td>\r\n    <td class="form-group">\r\n        <input type="text" id="mejoras_vnc" class="form-control money" disabled value="'+
((__t=(attributes.mejoras_vnc))==null?'':_.escape(__t))+
'" />\r\n    </td>\r\n    <td>\r\n        <div class="unbreakable"><span class="ion ion-ios-close text-red remove" aria-label="Remove"></span></div>\r\n    </td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/goodsDetail/sections/mejoras.ejs
// module id = 157
// module chunks = 0